import { TenantBranding } from '../api/auth';
import { deriveThemePalette } from './deriveThemePalette';
import { applyFontPairing } from './fontPairings';

/** Applies an org's stored theme to the live public site by overriding
 * ocen.css's `:root` custom properties (burgundy/gold/paper/ink/rule
 * families) and the active font pairing. */
export function applyOrgTheme(branding: TenantBranding): void {
  const palette = deriveThemePalette(branding);
  const root = document.documentElement.style;

  root.setProperty('--burgundy', palette.burgundy);
  root.setProperty('--burgundy-deep', palette.burgundyDeep);
  root.setProperty('--burgundy-soft', palette.burgundySoft);
  root.setProperty('--gold', palette.gold);
  root.setProperty('--gold-deep', palette.goldDeep);
  root.setProperty('--gold-pale', palette.goldPale);
  root.setProperty('--paper', palette.paper);
  root.setProperty('--ivory', palette.ivory);
  root.setProperty('--parchment', palette.parchment);
  root.setProperty('--paper-warm', palette.paperWarm);
  root.setProperty('--ink', palette.ink);
  root.setProperty('--ink-soft', palette.inkSoft);
  root.setProperty('--ink-mute', palette.inkMute);
  root.setProperty('--rule', palette.rule);
  root.setProperty('--rule-soft', palette.ruleSoft);

  root.setProperty('--ivory-rgb', palette.ivoryRgb);
  root.setProperty('--gold-rgb', palette.goldRgb);
  root.setProperty('--paper-rgb', palette.paperRgb);
  root.setProperty('--burgundy-deep-rgb', palette.burgundyDeepRgb);
  root.setProperty('--ink-rgb', palette.inkRgb);

  root.setProperty('--section-bg-dark', palette.sectionBgDark);
  root.setProperty('--section-text-dark', palette.sectionTextDark);
  root.setProperty('--section-bg-light', palette.sectionBgLight);
  root.setProperty('--section-text-light', palette.sectionTextLight);
  root.setProperty('--map-neighbor-dark', palette.mapNeighboringDark);

  applyFontPairing(branding.font_pairing);
}
